import React, { useState, useEffect } from "react";
import HomePage from "./components/home/HomePage";
import LoadingSpinner from "./components/common/LoadingSpinner";
import { AnimatePresence } from "framer-motion";
import "aos/dist/aos.css";
import AOS from "aos";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
      offset: 100
    });

    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <AnimatePresence>
        {isLoading ? (
          <LoadingSpinner key="loading" />
        ) : (
          <HomePage key="homepage" />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;